// extracted by mini-css-extract-plugin
module.exports = {"listBody":"ModelListPage_listBody__3m2HJ","paginatorBody":"ModelListPage_paginatorBody__7nrmy","numbering":"ModelListPage_numbering__z-3Zm"};